import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

/* eslint-disable @typescript-eslint/no-explicit-any */
const TYPE_TRANSLATIONS: { [key: string]: string } = {
  CREATE: "Criação",
  UPDATE: "Atualização",
  DELETE: "Exclusão",
};

const SOLICITATION_TRANSLATIONS: { [key: string]: string } = {
  BC: "Base de Cálculo",
  EXCEPTION: "Exceção",
};
export function InfoValues({ requestData }: { requestData: any }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-semibold text-gray-700">Email</Label>
          <Input
            value={requestData.email}
            disabled
            className="bg-white border-gray-200 h-10 text-gray-900 font-medium shadow-sm"
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-semibold text-gray-700">Responsável</Label>
          <Input
            value={requestData.responsible}
            disabled
            className="bg-white border-gray-200 h-10 text-gray-900 font-medium shadow-sm"
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-semibold text-gray-700">Tipo de Solicitação</Label>
          <Input
            value={
              TYPE_TRANSLATIONS[requestData.type_request] ||
              requestData.type_request
            }
            disabled
            className="bg-white border-gray-200 h-10 text-gray-900 font-medium shadow-sm"
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-semibold text-gray-700">Tipo</Label>
          <Input
            value={SOLICITATION_TRANSLATIONS[requestData.type_solicitation]}
            disabled
            className="bg-white border-gray-200 h-10 text-gray-900 font-medium shadow-sm"
          />
        </div>
        <div className="flex flex-col gap-2">
          <Label className="text-sm font-semibold text-gray-700">Criado em</Label>
          <Input
            value={format(
              new Date(requestData.created_at),
              "dd/MM/yyyy HH:mm:ss",
              { locale: ptBR }
            )}
            disabled
            className="bg-white border-gray-200 h-10 text-gray-900 font-medium shadow-sm"
          />
        </div>
      </div>
    </div>
  );
}
